import {Component, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {DashboardService} from '../services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('Fade', [
      state('true', style({
        opacity: '1',
      })),
      state('false', style({
        opacity: '0',
      })),
      transition('true => false', animate('10ms ease')),
      transition('false => true', animate('500ms ease'))
    ]),
  ]
})
export class DashboardComponent implements OnInit {
  public selectedGroup = 1;

  constructor(private dashboardService: DashboardService) {
  }

  ngOnInit(): void {
  }

  selectGroup(group: number) {
    this.selectedGroup = group;
  }

  kpi(name: string): any {
    return this.dashboardService.kpiData(name);
  }
}
